// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3L8Mz","upload":"Small_upload__1CbPg","imageWrap":"Small_imageWrap__SprSf","removeBtn":"Small_removeBtn__2TSC5"};